var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiHouseWithGarden(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:house-with-garden"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.8914 31.5635C24.1456 30.9108 25.1444 29.8561 25.7279 28.5682C26.3113 27.2804 26.4456 25.834 26.1092 24.4608C25.7728 23.0875 24.9852 21.867 23.8726 20.9946C22.76 20.1222 21.3868 19.6485 19.973 19.6494C18.5534 19.6493 17.1751 20.1274 16.0605 21.0065C14.9459 21.8856 14.1598 23.1146 13.8291 24.4951C13.7372 24.8662 13.5466 25.2055 13.2774 25.477C13.0082 25.7485 12.6706 25.9421 12.3003 26.0373C11.3914 26.2629 10.5446 26.6893 9.82216 27.2852C9.09971 27.881 8.51997 28.6312 8.12555 29.4806C7.73113 30.33 7.53205 31.2569 7.54295 32.1933C7.55384 33.1298 7.77444 34.0518 8.18852 34.8918C8.33757 35.2061 8.38318 35.5595 8.31879 35.9013C8.2544 36.2431 8.08333 36.5557 7.83014 36.7942C6.93076 37.618 6.30116 38.6943 6.02383 39.882C5.7465 41.0697 5.83435 42.3135 6.2759 43.4504C6.71744 44.5874 7.49208 45.5644 8.49835 46.2536C9.50461 46.9428 10.6956 47.3121 11.9152 47.3129H22.8895V31.5616L22.8914 31.5635Z",
    fill: "url(#paint0_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.8914 31.5635C24.1456 30.9108 25.1444 29.8561 25.7279 28.5682C26.3113 27.2804 26.4456 25.834 26.1092 24.4608C25.7728 23.0875 24.9852 21.867 23.8726 20.9946C22.76 20.1222 21.3868 19.6485 19.973 19.6494C18.5534 19.6493 17.1751 20.1274 16.0605 21.0065C14.9459 21.8856 14.1598 23.1146 13.8291 24.4951C13.7372 24.8662 13.5466 25.2055 13.2774 25.477C13.0082 25.7485 12.6706 25.9421 12.3003 26.0373C11.3914 26.2629 10.5446 26.6893 9.82216 27.2852C9.09971 27.881 8.51997 28.6312 8.12555 29.4806C7.73113 30.33 7.53205 31.2569 7.54295 32.1933C7.55384 33.1298 7.77444 34.0518 8.18852 34.8918C8.33757 35.2061 8.38318 35.5595 8.31879 35.9013C8.2544 36.2431 8.08333 36.5557 7.83014 36.7942C6.93076 37.618 6.30116 38.6943 6.02383 39.882C5.7465 41.0697 5.83435 42.3135 6.2759 43.4504C6.71744 44.5874 7.49208 45.5644 8.49835 46.2536C9.50461 46.9428 10.6956 47.3121 11.9152 47.3129H22.8895V31.5616L22.8914 31.5635Z",
    fill: "url(#paint1_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.8914 31.5635C24.1456 30.9108 25.1444 29.8561 25.7279 28.5682C26.3113 27.2804 26.4456 25.834 26.1092 24.4608C25.7728 23.0875 24.9852 21.867 23.8726 20.9946C22.76 20.1222 21.3868 19.6485 19.973 19.6494C18.5534 19.6493 17.1751 20.1274 16.0605 21.0065C14.9459 21.8856 14.1598 23.1146 13.8291 24.4951C13.7372 24.8662 13.5466 25.2055 13.2774 25.477C13.0082 25.7485 12.6706 25.9421 12.3003 26.0373C11.3914 26.2629 10.5446 26.6893 9.82216 27.2852C9.09971 27.881 8.51997 28.6312 8.12555 29.4806C7.73113 30.33 7.53205 31.2569 7.54295 32.1933C7.55384 33.1298 7.77444 34.0518 8.18852 34.8918C8.33757 35.2061 8.38318 35.5595 8.31879 35.9013C8.2544 36.2431 8.08333 36.5557 7.83014 36.7942C6.93076 37.618 6.30116 38.6943 6.02383 39.882C5.7465 41.0697 5.83435 42.3135 6.2759 43.4504C6.71744 44.5874 7.49208 45.5644 8.49835 46.2536C9.50461 46.9428 10.6956 47.3121 11.9152 47.3129H22.8895V31.5616L22.8914 31.5635Z",
    fill: "url(#paint2_radial_3261_1955)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.5061 46.1103C15.4969 45.0874 16.0931 42.2776 14.8378 39.8345C13.5825 37.3914 10.951 36.2402 8.96016 37.2631C6.96934 38.286 6.3731 41.0958 7.62842 43.5389C8.88373 45.982 11.5152 47.1332 13.5061 46.1103Z",
    fill: "url(#paint3_radial_3261_1955)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.17673 34.3545C10.5905 36.0706 13.4585 36.0433 15.5826 34.2934C17.7066 32.5436 18.2823 29.7338 16.8685 28.0177C15.4547 26.3016 12.5867 26.3289 10.4627 28.0788C8.33867 29.8287 7.76292 32.6384 9.17673 34.3545Z",
    fill: "url(#paint4_radial_3261_1955)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.1406 14.5483C19.1406 14.3713 19.2109 14.2016 19.336 14.0765C19.4611 13.9514 19.6308 13.8811 19.8078 13.8811H24.1616C24.3386 13.8811 24.5083 13.9514 24.6334 14.0765C24.7585 14.2016 24.8288 14.3713 24.8288 14.5483V30.3359H19.1387V14.5483H19.1406Z",
    fill: "url(#paint5_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.1406 14.5483C19.1406 14.3713 19.2109 14.2016 19.336 14.0765C19.4611 13.9514 19.6308 13.8811 19.8078 13.8811H24.1616C24.3386 13.8811 24.5083 13.9514 24.6334 14.0765C24.7585 14.2016 24.8288 14.3713 24.8288 14.5483V30.3359H19.1387V14.5483H19.1406Z",
    fill: "url(#paint6_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.1406 14.5483C19.1406 14.3713 19.2109 14.2016 19.336 14.0765C19.4611 13.9514 19.6308 13.8811 19.8078 13.8811H24.1616C24.3386 13.8811 24.5083 13.9514 24.6334 14.0765C24.7585 14.2016 24.8288 14.3713 24.8288 14.5483V30.3359H19.1387V14.5483H19.1406Z",
    fill: "url(#paint7_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M19.1406 14.5483C19.1406 14.3713 19.2109 14.2016 19.336 14.0765C19.4611 13.9514 19.6308 13.8811 19.8078 13.8811H24.1616C24.3386 13.8811 24.5083 13.9514 24.6334 14.0765C24.7585 14.2016 24.8288 14.3713 24.8288 14.5483V30.3359H19.1387V14.5483H19.1406Z",
    fill: "url(#paint8_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.1406 14.5483C19.1406 14.3713 19.2109 14.2016 19.336 14.0765C19.4611 13.9514 19.6308 13.8811 19.8078 13.8811H24.1616C24.3386 13.8811 24.5083 13.9514 24.6334 14.0765C24.7585 14.2016 24.8288 14.3713 24.8288 14.5483V30.3359H19.1387V14.5483H19.1406Z",
    fill: "url(#paint9_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint10_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint11_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint12_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint13_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint14_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint15_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M51.3372 53.4376H16.8398V31.9161L34.0876 14.7026L51.3334 31.9161V53.4376H51.3372Z",
    fill: "url(#paint16_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M32.3556 53.4358H21.2402V37.6216C21.2402 36.4168 22.0923 35.4275 23.1293 35.4275H30.4665C31.5035 35.4275 32.3537 36.4168 32.3537 37.6216L32.3556 53.4358Z",
    fill: "url(#paint17_linear_3261_1955)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M19.6191 52.2959H35.0598V54.1068H19.6191V52.2959Z",
    fill: "#68552B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_i_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M46.099 44.1942H39.3947C39.2184 44.1944 39.0438 44.1599 38.8809 44.0925C38.7179 44.0252 38.5699 43.9264 38.4452 43.8017C38.3206 43.677 38.2217 43.529 38.1544 43.366C38.087 43.2031 38.0525 43.0285 38.0527 42.8522V36.146C38.0527 35.393 38.6646 34.8059 39.3947 34.8059H46.099C46.852 34.8059 47.441 35.4159 47.441 36.146V42.8522C47.4431 43.029 47.4097 43.2044 47.343 43.3682C47.2763 43.5319 47.1775 43.6807 47.0525 43.8057C46.9275 43.9307 46.7787 44.0295 46.615 44.0962C46.4512 44.1629 46.2758 44.1962 46.099 44.1942Z",
    fill: "url(#paint18_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M46.099 44.1942H39.3947C39.2184 44.1944 39.0438 44.1599 38.8809 44.0925C38.7179 44.0252 38.5699 43.9264 38.4452 43.8017C38.3206 43.677 38.2217 43.529 38.1544 43.366C38.087 43.2031 38.0525 43.0285 38.0527 42.8522V36.146C38.0527 35.393 38.6646 34.8059 39.3947 34.8059H46.099C46.852 34.8059 47.441 35.4159 47.441 36.146V42.8522C47.4431 43.029 47.4097 43.2044 47.343 43.3682C47.2763 43.5319 47.1775 43.6807 47.0525 43.8057C46.9275 43.9307 46.7787 44.0295 46.615 44.0962C46.4512 44.1629 46.2758 44.1962 46.099 44.1942Z",
    fill: "url(#paint19_linear_3261_1955)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M46.0971 44.1942H39.3928C39.2165 44.1944 39.0419 44.1599 38.8789 44.0925C38.716 44.0252 38.568 43.9264 38.4433 43.8017C38.3186 43.677 38.2198 43.529 38.1524 43.366C38.0851 43.2031 38.0505 43.0285 38.0508 42.8522V36.146C38.0508 35.393 38.6627 34.8059 39.3928 34.8059H46.0971C46.85 34.8059 47.4391 35.4159 47.4391 36.146V42.8522C47.4411 43.029 47.4078 43.2044 47.3411 43.3682C47.2744 43.5319 47.1756 43.6807 47.0506 43.8057C46.9255 43.9307 46.7768 44.0295 46.613 44.0962C46.4493 44.1629 46.2739 44.1962 46.0971 44.1942Z",
    fill: "url(#paint20_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M46.0971 44.1942H39.3928C39.2165 44.1944 39.0419 44.1599 38.8789 44.0925C38.716 44.0252 38.568 43.9264 38.4433 43.8017C38.3186 43.677 38.2198 43.529 38.1524 43.366C38.0851 43.2031 38.0505 43.0285 38.0508 42.8522V36.146C38.0508 35.393 38.6627 34.8059 39.3928 34.8059H46.0971C46.85 34.8059 47.4391 35.4159 47.4391 36.146V42.8522C47.4411 43.029 47.4078 43.2044 47.3411 43.3682C47.2744 43.5319 47.1756 43.6807 47.0506 43.8057C46.9255 43.9307 46.7768 44.0295 46.613 44.0962C46.4493 44.1629 46.2739 44.1962 46.0971 44.1942Z",
    fill: "url(#paint21_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_ii_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M34.2635 51.6249H21.8672V36.6322C21.8672 35.4885 22.8165 34.5525 23.9736 34.5525H32.1552C33.3123 34.5525 34.2635 35.4904 34.2635 36.6303V51.6249Z",
    fill: "url(#paint22_linear_3261_1955)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M31.1568 44.2801C31.3936 44.2801 31.6208 44.186 31.7883 44.0185C31.9557 43.851 32.0498 43.6238 32.0498 43.387C32.0498 43.1501 31.9557 42.923 31.7883 42.7555C31.6208 42.588 31.3936 42.4939 31.1568 42.4939C30.9199 42.4939 30.6927 42.588 30.5252 42.7555C30.3578 42.923 30.2637 43.1501 30.2637 43.387C30.2637 43.6238 30.3578 43.851 30.5252 44.0185C30.6927 44.186 30.9199 44.2801 31.1568 44.2801Z",
    fill: "#62393D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_ii_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M31.3938 44.1446C31.633 44.1446 31.8623 44.0496 32.0314 43.8805C32.2005 43.7114 32.2955 43.4821 32.2955 43.243C32.2955 43.0038 32.2005 42.7745 32.0314 42.6054C31.8623 42.4363 31.633 42.3413 31.3938 42.3413C31.1547 42.3413 30.9254 42.4363 30.7563 42.6054C30.5872 42.7745 30.4922 43.0038 30.4922 43.243C30.4922 43.4821 30.5872 43.7114 30.7563 43.8805C30.9254 44.0496 31.1547 44.1446 31.3938 44.1446Z",
    fill: "#895D56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M55.8467 32.124L35.4499 12.0283C35.0854 11.6651 34.5919 11.4612 34.0774 11.4612C33.5628 11.4612 33.0693 11.6651 32.7049 12.0283C32.7049 12.0283 32.6858 12.0283 32.6858 12.0493L12.2413 32.1659C12.0616 32.342 11.9189 32.5521 11.8214 32.784C11.724 33.0159 11.6738 33.265 11.6738 33.5165C11.6738 33.768 11.724 34.0171 11.8214 34.249C11.9189 34.4809 12.0616 34.691 12.2413 34.8671C12.6081 35.2257 13.1008 35.4265 13.6138 35.4265C14.1268 35.4265 14.6194 35.2257 14.9863 34.8671L33.7304 16.3993C33.8196 16.3114 33.9398 16.2622 34.065 16.2622C34.1902 16.2622 34.3104 16.3114 34.3995 16.3993L53.0808 34.8023C53.4452 35.1655 53.9388 35.3694 54.4533 35.3694C54.9678 35.3694 55.4613 35.1655 55.8258 34.8023C56.5806 34.0455 56.6035 32.8579 55.8467 32.124Z",
    fill: "url(#paint23_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M20.2695 53.0544C20.2695 52.6753 20.4202 52.3116 20.6883 52.0435C20.9564 51.7754 21.32 51.6248 21.6992 51.6248H34.2805C34.6596 51.6248 35.0233 51.7754 35.2914 52.0435C35.5595 52.3116 35.7102 52.6753 35.7102 53.0544V53.4357H20.2695V53.0544Z",
    fill: "url(#paint24_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M20.2695 53.0544C20.2695 52.6753 20.4202 52.3116 20.6883 52.0435C20.9564 51.7754 21.32 51.6248 21.6992 51.6248H34.2805C34.6596 51.6248 35.0233 51.7754 35.2914 52.0435C35.5595 52.3116 35.7102 52.6753 35.7102 53.0544V53.4357H20.2695V53.0544Z",
    fill: "url(#paint25_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M20.2695 53.0544C20.2695 52.6753 20.4202 52.3116 20.6883 52.0435C20.9564 51.7754 21.32 51.6248 21.6992 51.6248H34.2805C34.6596 51.6248 35.0233 51.7754 35.2914 52.0435C35.5595 52.3116 35.7102 52.6753 35.7102 53.0544V53.4357H20.2695V53.0544Z",
    fill: "url(#paint26_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_i_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M3.95898 57.2788C3.95898 55.1572 5.67842 53.4377 7.80008 53.4377H53.2012C55.3248 53.4377 57.0442 55.1572 57.0442 57.2788H3.95898Z",
    fill: "#3FD47B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M3.95898 57.2788C3.95898 55.1572 5.67842 53.4377 7.80008 53.4377H53.2012C55.3248 53.4377 57.0442 55.1572 57.0442 57.2788H3.95898Z",
    fill: "url(#paint27_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M3.95898 57.2788C3.95898 55.1572 5.67842 53.4377 7.80008 53.4377H53.2012C55.3248 53.4377 57.0442 55.1572 57.0442 57.2788H3.95898Z",
    fill: "url(#paint28_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M3.95898 57.2788C3.95898 55.1572 5.67842 53.4377 7.80008 53.4377H53.2012C55.3248 53.4377 57.0442 55.1572 57.0442 57.2788H3.95898Z",
    fill: "url(#paint29_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    filter: "url(#filter10_i_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M49.3701 57.2789C50.5021 56.8725 51.4818 56.1277 52.176 55.1456C52.8703 54.1635 53.2457 52.9916 53.2513 51.7889C53.2513 48.554 50.5882 45.9329 47.3057 45.9329C46.3553 45.93 45.4179 46.1542 44.5717 46.5869C43.7255 47.0196 42.9949 47.6483 42.4409 48.4205C41.7833 49.3413 40.832 50.0904 39.8827 50.7042C39.3228 51.0626 38.8619 51.5559 38.5421 52.1387C38.2224 52.7216 38.0541 53.3754 38.0527 54.0402C38.0527 55.3745 38.7161 56.5564 39.736 57.2808L49.3701 57.2789Z",
    fill: "#2EAD69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M49.3701 57.2789C50.5021 56.8725 51.4818 56.1277 52.176 55.1456C52.8703 54.1635 53.2457 52.9916 53.2513 51.7889C53.2513 48.554 50.5882 45.9329 47.3057 45.9329C46.3553 45.93 45.4179 46.1542 44.5717 46.5869C43.7255 47.0196 42.9949 47.6483 42.4409 48.4205C41.7833 49.3413 40.832 50.0904 39.8827 50.7042C39.3228 51.0626 38.8619 51.5559 38.5421 52.1387C38.2224 52.7216 38.0541 53.3754 38.0527 54.0402C38.0527 55.3745 38.7161 56.5564 39.736 57.2808L49.3701 57.2789Z",
    fill: "url(#paint30_linear_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M49.3701 57.2789C50.5021 56.8725 51.4818 56.1277 52.176 55.1456C52.8703 54.1635 53.2457 52.9916 53.2513 51.7889C53.2513 48.554 50.5882 45.9329 47.3057 45.9329C46.3553 45.93 45.4179 46.1542 44.5717 46.5869C43.7255 47.0196 42.9949 47.6483 42.4409 48.4205C41.7833 49.3413 40.832 50.0904 39.8827 50.7042C39.3228 51.0626 38.8619 51.5559 38.5421 52.1387C38.2224 52.7216 38.0541 53.3754 38.0527 54.0402C38.0527 55.3745 38.7161 56.5564 39.736 57.2808L49.3701 57.2789Z",
    fill: "url(#paint31_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M49.3701 57.2789C50.5021 56.8725 51.4818 56.1277 52.176 55.1456C52.8703 54.1635 53.2457 52.9916 53.2513 51.7889C53.2513 48.554 50.5882 45.9329 47.3057 45.9329C46.3553 45.93 45.4179 46.1542 44.5717 46.5869C43.7255 47.0196 42.9949 47.6483 42.4409 48.4205C41.7833 49.3413 40.832 50.0904 39.8827 50.7042C39.3228 51.0626 38.8619 51.5559 38.5421 52.1387C38.2224 52.7216 38.0541 53.3754 38.0527 54.0402C38.0527 55.3745 38.7161 56.5564 39.736 57.2808L49.3701 57.2789Z",
    fill: "url(#paint32_radial_3261_1955)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M49.3682 57.2789C50.5002 56.8725 51.4798 56.1277 52.1741 55.1456C52.8684 54.1635 53.2438 52.9916 53.2493 51.7889C53.2493 48.554 50.5863 45.9329 47.3037 45.9329C46.3533 45.93 45.4159 46.1542 44.5697 46.5869C43.7235 47.0196 42.993 47.6483 42.439 48.4205C41.7813 49.3413 40.8301 50.0904 39.8808 50.7042C39.3209 51.0626 38.8599 51.5559 38.5402 52.1387C38.2205 52.7216 38.0522 53.3754 38.0508 54.0402C38.0508 55.3745 38.7142 56.5564 39.734 57.2808L49.3682 57.2789Z",
    fill: "url(#paint33_radial_3261_1955)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    filter: "url(#filter11_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M34.3926 12.991L54.8466 33.1324",
    stroke: "url(#paint34_linear_3261_1955)",
    strokeWidth: 1.39395,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    filter: "url(#filter12_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M34.3916 12.991L13.9375 33.1324",
    stroke: "url(#paint35_linear_3261_1955)",
    strokeOpacity: 0.5,
    strokeWidth: 1.39395,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    filter: "url(#filter13_f_3261_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M44.271 55.7844C43.3454 54.5901 42.6981 53.2042 42.3762 51.7279C42.3643 51.6679 42.3397 51.611 42.304 51.5613C42.2683 51.5116 42.2223 51.4702 42.1691 51.4398C42.116 51.4094 42.0569 51.3908 41.9959 51.3853C41.935 51.3798 41.8735 51.3874 41.8157 51.4077L41.4764 51.5354C40.9403 51.737 40.4919 52.1205 40.2097 52.6189C39.9275 53.1174 39.8294 53.6992 39.9325 54.2626C40.0355 54.8261 40.3333 55.3354 40.7736 55.7017C41.214 56.068 41.7691 56.268 42.3419 56.2667H44.0499C44.292 56.2667 44.4216 55.9731 44.271 55.7844Z",
    fill: "#31B570"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3261_1955",
    x: 5.86523,
    y: 19.6494,
    width: 21.3551,
    height: 28.5929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.929297,
    dy: 0.929297
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32324
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.301961 0 0 0 0 0.592157 0 0 0 0 0.392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3261_1955",
    x: 2.32422,
    y: 32.2432,
    width: 17.8184,
    height: 18.887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32324,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3261_1955",
    x: 3.75586,
    y: 22.1018,
    width: 18.5332,
    height: 18.1687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32324,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3261_1955",
    x: 18.917,
    y: 33.1042,
    width: 15.7617,
    height: 22.6548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16162,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_3261_1955",
    x: 17.2959,
    y: 49.9727,
    width: 20.0879,
    height: 6.45752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16162,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_3261_1955",
    x: 35.7295,
    y: 34.8059,
    width: 11.7119,
    height: 11.7117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.32324,
    dy: 2.32324
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16162
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.47451 0 0 0 0 0.792157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_3261_1955",
    x: 20.9379,
    y: 34.5525,
    width: 14.4874,
    height: 17.0723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.16162
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.16162
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.188235 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3261_1955"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.929297
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.696973
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.694118 0 0 0 0 0.470588 0 0 0 0 0.407843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3261_1955",
    result: "effect2_innerShadow_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_3261_1955",
    x: 29.5667,
    y: 41.7969,
    width: 3.18105,
    height: 3.18008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.348486,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_3261_1955",
    x: 30.0275,
    y: 42.3413,
    width: 2.73203,
    height: 1.80322,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.464648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.464648
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.694118 0 0 0 0 0.482353 0 0 0 0 0.419608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3261_1955"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.464648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.464648
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.290196 0 0 0 0 0.184314 0 0 0 0 0.164706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3261_1955",
    result: "effect2_innerShadow_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_3261_1955",
    x: 3.95898,
    y: 53.4377,
    width: 55.4092,
    height: 3.84106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.32324
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32324
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.25098 0 0 0 0 0.545098 0 0 0 0 0.352941 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_3261_1955",
    x: 38.0527,
    y: 45.9329,
    width: 16.1285,
    height: 12.2772,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.929297,
    dy: 0.929297
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.39395
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.564706 0 0 0 0 0.329412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_3261_1955",
    x: 30.9074,
    y: 9.50605,
    width: 27.4234,
    height: 27.1112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.39395,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_3261_1955",
    x: 10.4523,
    y: 9.50605,
    width: 27.4234,
    height: 27.1112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.39395,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_3261_1955",
    x: 36.4077,
    y: 47.8987,
    width: 11.4131,
    height: 11.8528,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74243,
    result: "effect1_foregroundBlur_3261_1955"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3261_1955",
    x1: 16.0747,
    y1: 19.6475,
    x2: 16.0747,
    y2: 47.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29884D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#227341"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3261_1955",
    x1: 11.9,
    y1: 47.6122,
    x2: 11.9,
    y2: 46.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E7978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E7978",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.4525 18.2426) rotate(90) scale(5.36956 5.00465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#4DB56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DB56F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.104 43.1348) rotate(-37.7036) scale(7.7219 12.921)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279D5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#279D5A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.0696 29.0434) rotate(40.6049) scale(5.82772 9.83196)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EA75B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EA75B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.0587 14.8018) rotate(90) scale(7.30698 3.62779)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3261_1955",
    x1: 18.746,
    y1: 20.2365,
    x2: 21.1269,
    y2: 20.2365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E694B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E694B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3261_1955",
    x1: 23.4068,
    y1: 22.1085,
    x2: 22.366,
    y2: 20.8809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C77958"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C77958",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3261_1955",
    x1: 21.9828,
    y1: 13.7915,
    x2: 21.9828,
    y2: 14.0584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5AD80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5AD80",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.496 14.1747) rotate(180) scale(3.94144 0.847233)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3261_1955",
    x1: 18.0961,
    y1: 40.0176,
    x2: 50.3841,
    y2: 40.0176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7905F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8BC97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3261_1955",
    x1: 19.0053,
    y1: 54.3374,
    x2: 31.6571,
    y2: 36.1022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA8951"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8951",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7054 52.1867) rotate(-117.235) scale(6.05568 7.32499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAB75",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3261_1955",
    x1: 51.3353,
    y1: 45.2999,
    x2: 50.2278,
    y2: 45.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.7433 30.6332) rotate(90) scale(7.55207 1.59755)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9E413E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E413E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3261_1955",
    x1: 39.894,
    y1: 21.3669,
    x2: 39.1506,
    y2: 22.1103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B55852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B55852",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3261_1955",
    x1: 16.6302,
    y1: 48.9942,
    x2: 17.8082,
    y2: 48.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#845F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#845F3D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3261_1955",
    x1: 26.797,
    y1: 35.4275,
    x2: 26.797,
    y2: 53.4358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D4D2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3261_1955",
    x1: 38.0527,
    y1: 44.9033,
    x2: 48.1845,
    y2: 34.8059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A9EE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3261_1955",
    x1: 42.7478,
    y1: 44.7832,
    x2: 42.7478,
    y2: 42.9361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E9FE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E9FE4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3261_1955",
    x1: 38.0508,
    y1: 41.8076,
    x2: 39.9361,
    y2: 41.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#48E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48E0FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3261_1955",
    x1: 39.4709,
    y1: 33.1627,
    x2: 40.7348,
    y2: 36.9523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43B3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B3F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3261_1955",
    x1: 21.8672,
    y1: 45.2599,
    x2: 34.2635,
    y2: 45.1798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70504D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B665E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3261_1955",
    x1: 34.0392,
    y1: 11.4602,
    x2: 34.0392,
    y2: 35.4275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6D2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA222B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3261_1955",
    x1: 20.6851,
    y1: 53.4376,
    x2: 35.1478,
    y2: 53.4376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FA1A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C1C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3261_1955",
    x1: 20.0103,
    y1: 53.4376,
    x2: 21.8517,
    y2: 53.4376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59675C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59675C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3261_1955",
    x1: 35.7102,
    y1: 52.5302,
    x2: 34.0003,
    y2: 53.4376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8CAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8CAC6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3261_1955",
    x1: 30.5016,
    y1: 58.2987,
    x2: 30.5016,
    y2: 55.3573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    stopColor: "#3FD17B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FD17B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.602 55.3573) rotate(128.096) scale(3.66896 4.62853)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#228051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#228051",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0457 52.8823) rotate(147.147) scale(6.36895 10.4435)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CEE92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CEE92",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3261_1955",
    x1: 43.924,
    y1: 58.4341,
    x2: 43.924,
    y2: 54.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B8478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7136 62.9481) rotate(-110.329) scale(12.9634 5.90502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C785B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C785B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6542 49.9131) rotate(142.112) scale(14.4284 19.5293)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#2C785B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.966,
    stopColor: "#2C785B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3261_1955",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6885 48.7407) rotate(148.884) scale(8.22415 7.8292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60FB9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60FB9A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3261_1955",
    x1: 33.7654,
    y1: 12.6783,
    x2: 55.7045,
    y2: 35.2674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24747"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3261_1955",
    x1: 35.0206,
    y1: 12.6783,
    x2: 13.0816,
    y2: 35.2674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F24747"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiHouseWithGarden);
export default __webpack_public_path__ + "static/media/fluent-emoji_house-with-garden.cdf11d6f693287a285c43470c6f14957.svg";
export { ForwardRef as ReactComponent };